<template>
  <div class="step3">
    <!-- ケーキのサイズについて -->
    <div class="noticeSize">
      ホールケーキのサイズについて
      <ul>
        <li>４号：２〜３名様分の小さなケーキ</li>
        <li>５号：４〜６名様分の標準的なサイズ</li>
        <li>６号：７〜１０名様分の少し大きめサイズ</li>
        <li>７号：１１〜１４名様分の大きめサイズ</li>
      </ul>
    </div>
    <!-- /ケーキのサイズについて -->

    <div v-if="items_disable">
      <p>1月2日受け取り分のご予約の受付は終了いたしました。</p>
    </div>
    <div class="step3--main" v-else>
      <div class="selectCat">
        <p class="selectCat__text1">カテゴリーで絞り込む</p>
        <div class="selectCatBtnBox">
          <!-- <button class="category" id="catAll" @click="selectAll">全商品</button> -->
          <button
            v-for="(cat, index) in filterCategoryBySelectedDate(category)"
            :key="index"
            class="category catBtn"
            @click="selectCat(cat.id, cat.name)"
            v-bind:id="cat.name"
          >
            {{ cat.name }}
          </button>
        </div>
      </div>
      <!--商品リスト-->
      <div class="itemList">
        <!--商品-->
        <div
          v-for="(item, index) in setPriorMessagePlate(reservation.showItemList)"
          :key="index"
          v-bind:class="item._embedded['wp:term'][0][0].name"
          class="itemBox"
          @click="
            openModal(item, index)
            showCartContents(item)
          "
        >
          <p class="itemBox--imgBlock" v-bind:id="['item' + index]">
            <img v-bind:src="item.acf.images[0].image.sizes.medium" class="itemBox--imgBlock--img" /><i
              class="fas fa-plus"
            ></i>
          </p>
          <!-- <p class="itemBox--categoryName">{{ item._embedded['wp:term'][0][0].name }}</p> -->
          <p class="itemBox--itemName text-center">{{ item.title.rendered }}</p>
          <p class="itemBox--itemPrice text-center">
            {{ item.min_price | calcTax(item.title.rendered) | addComma }}円(税込)〜
          </p>
        </div>
        <div class="itemBox none"></div>
        <div class="itemBox none"></div>
        <div class="itemBox none"></div>
        <div class="itemBox none"></div>
        <p class="mr-auto ml-auto mt-4" v-if="seenNoItemtext">指定された日時ではご用意できる商品がありません。</p>
      </div>
    </div>

    <!--カートモーダル-->
    <div class="modal_cart" id="modalCart">
      <div class="modal_cart_white">
        <p class="stopButton" id="stopButtonCart" @click="closePopUpCart"><i class="fas fa-times"></i></p>
        <div class="step3--cart" v-if="seenCart">
          <p class="step3--cart__title">カートの中身</p>
          <div v-for="(itemCart, index) in reservation.cart" :key="index" class="step3--cart--list">
            <p class="step3--cart--list__img"><img v-bind:src="itemCart.image" style="max-width: 100%" /></p>
            <div class="step3--cart--list__price">
              <p>{{ itemCart.name }}</p>
              <p>
                {{ itemCart.price | calcTax(itemCart.name) | addComma }}円（税込）<br class="d-block d-md-none" />{{
                  itemCart.number
                }}個
              </p>
              <div v-if="itemCart.original == 'カットケーキ用メッセージカード'">
                メッセージプレートの内容<br />{{ itemCart.cut_cake_message }}
              </div>
              <!--ろうそくの本数・メッセージ（出し分け）-->
              <div v-if="seenInCartContents(itemCart)">
                <p>ローソクの数　大{{ itemCart.candle.big }}本 小{{ itemCart.candle.small }}本</p>
                <div>
                  メッセージプレートの内容<br />
                  1枚目：{{ itemCart.message }}<br />
                  <div class="cart-second-message" v-show="itemCart.message_2_enabled">
                    <div>
                      <i class="second-message-icon fa-regular fa-square-check"></i>2枚目を希望する　+108円（税込）
                    </div>
                    <div>2枚目：{{ itemCart.message_2 }}</div>
                  </div>
                </div>
              </div>
            </div>
            <p class="hiddenSum">
              {{ (Number(itemCart.price) + (itemCart.message_2_enabled ? 100 : 0)) * itemCart.number }}
            </p>
            <p
              class="step3--cart--list__dele"
              @click="
                deleCartItem(index)
                hideCart()
              "
            >
              削除
            </p>
          </div>
          <div class="step3--cart__sum">
            <p>小計 {{ sumWithreducedTaxRate(reservation.sum) | addComma }}円</p>
            <p>内税 {{ Math.trunc(calcWithreducedTaxRate(reservation.sum)) | addComma }}円</p>
            <p>
              合計 <span>{{ sumWithreducedTaxRate(reservation.sum) | addComma }}円</span>
            </p>
          </div>
          <div class="btnBox">
            <button class="btn btn_blue text-center" @click="closePopUpCart" type="button">
              <i class="fas fa-chevron-left"></i>ショッピングを続ける
            </button>
            <button class="btn text-center" @click="next" type="button">
              お客様情報入力へすすむ<i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /カートモーダル -->

    <!--モーダル-->
    <div class="modal" id="modal" ref="modal__content">
      <div id="modal--whiteBlock">
        <div id="modal--contents" class="modal__contents">
          <p class="stopButton" id="stopButton" @click="closeModal"><i class="fas fa-times"></i></p>
          <!--タイトル（商品名）-->
          <p class="modal__contents--itemName">{{ reservation.item.name }}</p>
          <div class="modal--content">
            <!--タイトル（写真部分）-->
            <div class="modal--contentImg">
              <p><img v-bind:src="reservation.item.images.main" class="modal--contentImg--main" /></p>
              <div class="modal--contentImg--thum" v-show="thumLength > 1">
                <img
                  v-for="(thum, index) in reservation.item.images.thum"
                  :key="index"
                  v-bind:src="thum"
                  @click="thumImgClick(thum)"
                />
              </div>
              <p class="mt-2 mt-sm-3 mb-2 mb-sm-3">
                <small>※ 写真はイメージです。実際のデザインとは異なる場合がございますのでご了承ください。</small>
              </p>
              <p class="caution">「商品サイズ」「メッセージ内容」「ローソクの本数」をご指定ください。</p>
            </div>

            <!--タイトル（フォーム部分）-->
            <div class="modal--contentForm">
              <div class="modal--contentForm__desc" v-html="this.reservation.item.desc"></div>

              <!-- サイズ・規格 -->
              <div class="label_kikaku">
                <label
                  v-for="(kikaku, index) in reservation.item.kikaku"
                  :key="index"
                  class="kikakuLabel"
                  @click="radioAddClass(index)"
                  :class="{ d_none: isEnough(kikaku) }"
                  :data-val="kikaku.kikaku_size"
                  name="kikaku"
                >
                  <div class="select_radio_btn"></div>
                  <!-- <input type="radio" name="kikaku" :value="kikaku.kikaku_size" hidden /> -->
                  <span class="kikakuLabel__txt"
                    >{{ kikaku.kikaku_size }}（ {{ kikaku.kikaku_price | calcTax(reservation.item.name) | addComma }}円
                    )</span
                  >
                </label>
              </div>

              <!-- 個数 -->
              <div class="modal--contentForm__number pt-2">
                <label class="modal--contentForm__number--label">数量</label>
                <input
                  type="number"
                  id="number"
                  min="1"
                  class="modal--contentForm__number--input form-control"
                  value="1"
                  size="3"
                />個
              </div>
              <p class="numberNotice text-danger">
                数が多いご注文の際はご希望にお応えできない場合がございますので、こちらからお電話させていただきます。連絡が取れない際には、キャンセルさせていただく場合がございます。ご了承くださいませ。
              </p>

              <p class="numberNotice text-danger">
                ※カットケーキのメッセージカードをご利用の方は100円/1枚＋税でご用意します。
              </p>

              <div v-if="reservation.item.name === 'カットケーキ用メッセージカード'">
                <div class="modal--contentForm__msg pt-2 mb-0">
                  <label class="modal--contentForm__msg--label mr-3"> メッセージプレートの内容 </label>
                  <input
                    type="text"
                    id="message"
                    :value="cut_cake_message"
                    @input="event => (cut_cake_message = event.target.value)"
                    placeholder="例：◯◯ちゃんおたんじょうびおめでとう"
                    class="modal--contentForm__msg--input form-control"
                  />
                </div>
                <p class="numberNotice text-danger">
                  <small>※チョコペンで手書きいたしますので、画像とは異なります。</small><br />
                  <small>※絵文字のご利用は、正しく表示されないことがございますのでお控えください</small><br />
                  <small>※20文字以内でお願いいたします。</small><br />
                  <small
                    >※プラザ店受け取りのみ、メッセージプレートは別添えになります。ケーキにのせた状態でのお渡しではありません。</small
                  >
                </p>
              </div>

              <div v-if="seenCartContents">
                <p class="modal--contentForm__msg pt-2 mb-0">
                  <label class="modal--contentForm__msg--label mr-3"> メッセージプレートの内容 </label>
                  <input
                    type="text"
                    id="message"
                    :value="v1_message"
                    @input="event => (v1_message = event.target.value)"
                    placeholder="例：◯◯ちゃんおたんじょうびおめでとう"
                    class="modal--contentForm__msg--input form-control"
                  />
                </p>
                <p class="modal--contentForm__msg pt-2 mb-0">
                  <label class="modal--contentForm__msg--label mr-3"> 2枚目を追加 </label>
                  <label label href="message_2_shown" class="message-2-container">
                    <input
                      type="checkbox"
                      class="message-2__input"
                      name="message_2_shown"
                      v-model="message_2_shown"
                      id="message_2_shown"
                    />
                    <div class="message-2__label">
                      希望する<span class="message-2__label_tax">+税込108円（税込）</span>
                    </div>
                  </label>
                </p>
                <p class="modal--contentForm__msg pt-2 mb-0" v-if="message_2_shown">
                  <label class="modal--contentForm__msg--label mr-3"> 2枚目の内容 </label>
                  <input
                    type="text"
                    id="message_2"
                    :value="v2_message"
                    @input="event => (v2_message = event.target.value)"
                    placeholder="例：◯◯ちゃんおたんじょうびおめでとう"
                    class="modal--contentForm__msg--input form-control"
                  />
                </p>
                <p class="numberNotice text-danger">
                  <small>※絵文字のご利用は、正しく表示されないことがございますのでお控えください</small><br />
                  <small>※20文字以内でお願いいたします。</small><br />
                  <small
                    >※プラザ店受け取りのみ、メッセージプレートは別添えになります。ケーキにのせた状態でのお渡しではありません。</small
                  >
                </p>
                <div class="modal--contentForm__candle">
                  <span class="modal--contentForm__candle--text1">ローソクの数</span>
                  <div class="div">
                    <div class="mr-3">
                      <span class="modal--contentForm__candle--text2">大</span>
                      <select name="" id="candleBig" class="inputNumber form-control">
                        <option value="0" selected>０</option>
                        <option value="1">１</option>
                        <option value="2">２</option>
                        <option value="3">３</option>
                        <option value="4">４</option>
                        <option value="5">５</option>
                        <option value="6">６</option>
                        <option value="7">７</option>
                        <option value="8">８</option>
                        <option value="9">９</option>
                      </select>
                      <span class="modal--contentForm__candle--text2">本</span>
                    </div>
                    <br />
                    <div>
                      <span class="modal--contentForm__candle--text2">小</span>
                      <select name="" id="candleSmall" class="inputNumber form-control">
                        <option value="0" selected>０</option>
                        <option value="1">１</option>
                        <option value="2">２</option>
                        <option value="3">３</option>
                        <option value="4">４</option>
                        <option value="5">５</option>
                        <option value="6">６</option>
                        <option value="7">７</option>
                        <option value="8">８</option>
                        <option value="9">９</option>
                      </select>
                      <span class="modal--contentForm__candle--text2">本</span>
                    </div>
                  </div>
                </div>
              </div>
              <p style="color: #dc3545" v-for="(error, i) in errorMessages" :key="i">{{ error }}</p>
              <button
                class="btn d-none d-md-block"
                id="cartIn"
                @click="
                  cartIn()
                  showCart()
                "
              >
                カートに入れる<i class="fas fa-chevron-right"></i>
              </button>

              <button
                class="btn d-md-none"
                id="cartIn"
                @click="
                  cartIn()
                  showCart()
                "
              >
                カートに入れる<i class="fas fa-chevron-right"></i>
              </button>

              <p style="font-size: 12px; margin: 30px 0">
                <strong style="color: #dc3545"
                  >熨斗をご希望のお客様は、お客様情報入力画面の備考欄に熨斗の内容と内のし、外のしをご入力</strong
                >ください。<br />
                ご指定が無い場合は内のしでご用意いたします。<br />
                熨斗のご指定が無い場合は包装のみでご用意させていただきます。
              </p>
            </div>
            <!-- /タイトル（フォーム部分）-->
          </div>
        </div>
      </div>
    </div>
    <!-- /モーダル -->
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'step3',
  data() {
    return {
      cut_cake_message: '', // カットケーキのメッセージカード
      v2_message: '',
      v1_message: '',
      message_2_shown: false,
      items_disable: false,
      seenNoItemtext: false,
      thumDisplay: true,
      errorMessages: []
    }
  },
  props: [
    'seen',
    'buttonText',
    'step',
    'shops',
    'items',
    'radioResult',
    'reservation',
    'category',
    'seenCart',
    'seenCartContents',
    'AppSum'
  ],
  watch: {
    v1_message: function(val) {
      if (val.length > 20) {
        if (this.errorMessages.indexOf('1枚目のメッセージは20文字以内でご入力ください') === -1) {
          this.errorMessages.push('1枚目のメッセージは20文字以内でご入力ください')
        }
        // this.errorMessages.push('1枚目のメッセージは20文字以内でご入力ください')
      } else {
        this.errorMessages = this.errorMessages.filter(errMsg => errMsg !== 'メッセージは20文字以内でご入力ください')
      }

      if (this.message_2_shown) {
        if (val.length == 0) {
          if (this.errorMessages.indexOf('1枚目のメッセージを入力してください') === -1) {
            this.errorMessages = ['1枚目のメッセージを入力してください', ...this.errorMessages]
          }
        } else {
          this.errorMessages = this.errorMessages.filter(errMsg => errMsg !== '1枚目のメッセージを入力してください')
        }
      }
    },
    v2_message: function(val) {
      if (val.length > 20) {
        if (this.errorMessages.indexOf('2枚目のメッセージは20文字以内でご入力ください') === -1) {
          this.errorMessages.push('2枚目のメッセージは20文字以内でご入力ください')
        }
        // this.errorMessages.push('2枚目のメッセージは20文字以内でご入力ください')
      } else {
        this.errorMessages = this.errorMessages.filter(
          errMsg => errMsg !== '2枚目のメッセージは20文字以内でご入力ください'
        )
      }

      // 2枚目が必須
      if (this.message_2_shown) {
        if (val.length == 0) {
          if (this.errorMessages.indexOf('2枚目のメッセージを入力してください') === -1) {
            this.errorMessages.push('2枚目のメッセージを入力してください')
          }
        } else {
          this.errorMessages = this.errorMessages.filter(errMsg => errMsg !== '2枚目のメッセージを入力してください')
        }
      }
    },
    cut_cake_message: function(val) {
      if (this.reservation.item?.original == 'カットケーキ用メッセージカード') {
        if (val.length > 20) {
          if (this.errorMessages.indexOf('メッセージは20文字以内でご入力ください') === -1) {
            this.errorMessages.push('メッセージは20文字以内でご入力ください')
          }
        } else {
          this.errorMessages = this.errorMessages.filter(errMsg => errMsg !== 'メッセージは20文字以内でご入力ください')
        }

        if (val.length == 0) {
          if (this.errorMessages.indexOf('メッセージを入力してください') === -1) {
            this.errorMessages.push('メッセージを入力してください')
          }
        } else {
          this.errorMessages = this.errorMessages.filter(errMsg => errMsg !== 'メッセージを入力してください')
        }
      }
    },
    message_2_shown: function(val) {
      if (!val) {
        this.errorMessages = this.errorMessages.filter(errMsg => errMsg != '2枚目のメッセージを入力してください')
        this.errorMessages = this.errorMessages.filter(errMsg => errMsg !== '1枚目のメッセージを入力してください')
        this.v2_message = ''
      }
    }
  },
  mounted() {
    let now = new Date()
    let month = now.getMonth() + 1 // JavaScriptでは月は0から始まるので+1
    let day = now.getDate()

    if (this.reservation.month == 1 && this.reservation.date == 2) {
      // 1/2を選択した時
      if ((month === 12 && day >= 28) || (month === 1 && day === 1)) {
        // if (true) {
        // その日(リアルタイム)が12/28~1/1だった場合
        this.items_disable = true
      } else {
        this.items_disable = false
      }
    } else {
      this.items_disable = false
    }

    this.showNoItemText()
    this.checkSeen()
    this.border()
    const cat = document.getElementsByClassName('category')
    cat[0].classList.add('active')

    if (this.filterdCategoryBySelectedDate) {
      this.selectCat(11, '焼菓子')
    }
  },
  updated() {
    //枠線の付与
    this.border()

    this.initRadioBtn()

    //selectbox(option)の削除
    let option_kikaku = document.getElementsByClassName('option_kikaku')
    for (let i = option_kikaku.length - 1; 0 <= i; --i) {
      //IE対策用
      if (option_kikaku[i].classList.contains('d_none')) {
        option_kikaku[i].parentNode.removeChild(option_kikaku[i])
      }
    }
    if (document.getElementById('pageHeaderCartBtn')) {
      const pageHeaderCartBtn = document.getElementById('pageHeaderCartBtn')
      if (pageHeaderCartBtn.style.display == 'block') {
        const pageHeaderCartBtn_first = document.getElementById('pageHeaderCartBtn_first')
        pageHeaderCartBtn_first.style.display = 'none'
      }
    }
  },
  computed: {
    filterdCategoryBySelectedDate: function() {
      // 12/22,23,24,25
      return this.reservation.month == 12 && [22, 23, 24, 25].includes(Number(this.reservation.date))
    },
    thumLength: function() {
      return Object.keys(this.reservation.item.images.thum).length
    }
  },
  filters: {
    addComma: function(val) {
      return String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    calcTax: function(num, title) {
      // titleは商品名
      if (title && /ナンバーキャンドル/.test(title)) {
        return Math.trunc(Number(num) * 1.1)
      } else {
        return Math.trunc(Number(num) * 1.08)
      }
    }
  },
  methods: {
    setPriorMessagePlate: function(items) {
      // 新しい配列を作成してソートする
      return [...items].sort((a, b) => {
        if (a.title.rendered === 'カットケーキ用メッセージカード') return -1
        if (b.title.rendered === 'カットケーキ用メッセージカード') return 1
        return 0
      })
    },
    sumWithreducedTaxRate: function() {
      // 税込の総額を算出
      // カート内にあるナンバーキャンドルの合計金額を計算
      const candleTotalPrice = this.reservation.cart.reduce((acc, cur) => {
        if (cur.cat === 'ナンバーキャンドル') {
          return acc + Number(cur.number) * Number(cur.price)
        } else return acc
      }, 0)

      // 合計（税込）を計算
      return Math.trunc((this.reservation.sum - candleTotalPrice) * 1.08) + Math.trunc(candleTotalPrice * 1.1)
    },
    calcWithreducedTaxRate: function() {
      //  税の合計を算出
      // カート内にあるナンバーキャンドルの合計金額を計算
      const candleTotalPrice = this.reservation.cart.reduce((acc, cur) => {
        if (cur.cat === 'ナンバーキャンドル') {
          return acc + Number(cur.number) * Number(cur.price)
        } else return acc
      }, 0)

      return Math.trunc((this.reservation.sum - candleTotalPrice) * 0.08) + Math.trunc(candleTotalPrice * 0.1)
    },
    addMessage2Price: function(price, count, enabled_message2) {
      return enabled_message2 ? Number(price) + 100 : price
    },
    //　日付によるカテゴリのホワイトリスト
    filterCategoryBySelectedDate(category) {
      // A日はxxとxxのみのような条件
      if (this.filterdCategoryBySelectedDate) {
        // 焼菓子のみ表示
        const whitelist = [11]
        return category.filter(cat => whitelist.includes(cat.id))
      } else return category // 条件に当てはまらない場合は全て表示
    },
    // ラジオボタン初期化
    initRadioBtn() {
      const kikakuLabel = document.getElementsByClassName('kikakuLabel')
      const initClass = document.getElementsByClassName('kikakuLabel current')

      if (!initClass.length > 0) {
        for (let i = 0; i < kikakuLabel.length; i++) {
          if (!kikakuLabel[i].classList.contains('d_none')) {
            kikakuLabel[i].classList.add('current')
            break
          } else {
          }
        }
      }
    },

    //ステップを次に進める処理
    next: function() {
      this.$emit('next')
    },
    //ステップを前に戻す処理
    prev: function(number) {
      this.$emit('prev', number)
    },
    //枠線の再描画
    border: function() {
      //カートに入っている商品に枠をつける
      if (this.reservation.showItemList.length !== 0) {
        for (let i = 0; i < this.reservation.showItemList.length; i++) {
          if (document.getElementById('item' + i)) {
            let id = '#item' + i
            let itemBox = $(id)
            itemBox.parent('.itemBox').css('border', 'solid 1px #d8d8d8')
          }
        }
        if (this.reservation.cart.length !== 0) {
          for (let i = 0; i < this.reservation.cart.length; i++) {
            for (let j = 0; j < this.reservation.showItemList.length; j++) {
              if (this.reservation.cart[i].original === this.reservation.showItemList[j].title.rendered) {
                if (document.getElementById('item' + j)) {
                  let id = '#item' + j
                  let itemBox = $(id)
                  itemBox.parent('.itemBox').css('border', 'solid 3px #0d446f')
                }
              }
            }
          }
        }
      }
    },
    //リードタイムの計算(radioのdisplay-classの付与)
    isEnough: function(kikaku) {
      if (kikaku.boolean) {
        return false
      } else {
        return true
      }
    },
    //カートの表示・非表示
    showCart: function() {
      this.$emit('showCart')
    },
    hideCart: function() {
      this.$emit('hideCart')
    },
    //カートの中身の表示・非表示
    showCartContents: function(item) {
      this.$emit('showCartContents', item)
    },
    //商品一覧のサムネイル画像のクリック時の処理
    thumImgClick: function(src) {
      // let kikakuLabel = document.getElementsByClassName('kikakuLabel')
      // for (let i = 0; i < kikakuLabel.length; i++) {

      // }
      this.reservation.item.images.main = src
    },
    //もっとみるボタンの表示・非表示
    checkSeen: function() {
      this.$emit('checkSeen')
    },
    //カテゴリー検索（全選択）
    selectAll: function() {
      this.$emit('selectAll')
      this.showNoItemText()
    },
    //カテゴリー検索（カテゴリー別）
    selectCat: function(catId, catName) {
      this.$emit('selectCat', catId, catName)
      this.showNoItemText()
    },
    openModal: function(item, index) {
      this.errorMessages = []
      let modal = document.getElementById('modal')
      modal.style.display = 'block'
      this.reservation.item.name = item.title.rendered
      this.reservation.item.original = item.title.rendered
      this.reservation.item.price = item.acf.price
      this.reservation.item.cat = item._embedded['wp:term'][0][0].name
      this.reservation.item.desc = item.acf.description
      this.reservation.item.images.main = item.acf.images[0].image.sizes.medium
      this.reservation.item.images.reserMain = item.acf.images[0].image.sizes.medium
      this.reservation.item.images.thum = {}
      for (let i = 0; i < item.acf.images.length; i++) {
        this.reservation.item.images.thum[i] = item.acf.images[i].image.sizes.medium
      }
      //規格・サイズの取得
      this.reservation.item.kikaku = item.acf.kikaku
      for (let i = 0; i < this.reservation.item.kikaku.length; i++) {
        if (this.reservation.item.kikaku[i].kikaku_size === '') {
          this.reservation.item.kikaku[i].kikaku_size = 'サイズなし'
        }
      }
      // 予約時の商品ごとの番号（postId）
      this.reservation.item.reserId = item.id
      //枠をつける（IDの取得）
      let item_select_id = 'item' + index
      this.reservation.item.id = item_select_id
      // サムネイルを表示するか非表示にするか判定（サムネイルが１個以下なら非表示）
      if (Object.keys(this.reservation.item.images.thum).length <= 1) {
        this.thumDisplay = false
      }
    },
    resetForm: function() {
      // inputの状態を初期値に戻す
      const number = document.getElementById('number')
      const message = document.getElementById('message')
      const message_2 = document.getElementById('message_2')
      const candleBig = document.getElementById('candleBig')
      const candleSmall = document.getElementById('candleSmall')

      if (number) {
        number.value = 1
      }
      if (message) {
        this.v1_message = ''
        message.value = ''
      }
      if (message_2) {
        this.v2_message = ''
        message_2.value = ''
      }
      if (candleBig) {
        candleBig.options[0].selected = true
      }
      if (candleSmall) {
        candleSmall.options[0].selected = true
      }
      this.message_2_shown = false
      this.cut_cake_message = ''
    },
    closeModal: function() {
      // inputの状態を初期値に戻す
      this.$refs.modal__content.scrollTop = 0 //スクロール位置をトップに戻す
      this.resetForm()
      this.thumDisplay = true //モーダル画像一枚非表示制御 初期化

      let modal = document.getElementById('modal')
      modal.style.display = 'none'
      //labelのcurrent表示をもとに戻す
      let kikakuLabel = document.getElementsByClassName('kikakuLabel')
      for (let i = 0; i < kikakuLabel.length; i++) {
        kikakuLabel[i].classList.remove('current')
      }

      // this.initRadioBtn()
    },
    cartIn: function(catName) {
      this.$refs.modal__content.scrollTop = 0

      // バリデーション
      this.errorMessages = []
      let message_1 = document.getElementById('message')

      let isError = false
      if (message_1 && message_1.value.length > 20) {
        this.errorMessages.push('メッセージ（1枚目）は20文字以内でご入力ください')
        isError = true
      }

      if (this.message_2_shown) {
        // もし2枚目メッセージを有効にしている場合
        // 1枚目も2枚目も必須にする
        let message_1 = document.getElementById('message')
        let message_2 = document.getElementById('message_2')

        if (message_1 != null) {
          if (message_1.value.length == 0) {
            this.errorMessages.push('1枚目のメッセージを入力してください')
            isError = true
          }

          if (message_1 && message_1.value.length > 20) {
            this.errorMessages.push('メッセージ（1枚目）は20文字以内でご入力ください')
            isError = true
          }
        }

        if (message_2 != null) {
          if (message_2.value.length == 0) {
            this.errorMessages.push('2枚目のメッセージを入力してください')
            isError = true
          }
          if (message_2 && message_2.value.length > 20) {
            this.errorMessages.push('メッセージ（2枚目）は20文字以内でご入力ください')
            isError = true
          }
        }
      }

      if (this.reservation.item.name === 'カットケーキ用メッセージカード') {
        if (this.cut_cake_message === '') {
          this.errorMessages.push('メッセージを入力してください')
          isError = true
        }

        if (this.cut_cake_message.length > 20) {
          this.errorMessages.push('メッセージは20文字以内でご入力ください')
          isError = true
        }
      }

      // バリデーションエラーであれば処理を中断
      if (isError) return

      ///////////////////////////////////////////////////////////////////////////
      //alertを出す
      let number_alert = document.getElementById('number').value
      let maxItemNumber = parseInt(number_alert, 10) + parseInt(this.reservation.totalCartItemNumber, 10)
      // if (maxItemNumber > 3) {
      //   alert('一度に予約できる商品の個数は３つまでです。')
      //   return
      // }
      ///////////////////////////////////////////////////////////////////////////

      //最初に名前の取得(商品名でカートの中身を検索するため)
      let kikakuName = document.getElementsByName('kikaku')
      for (let i = 0; i < kikakuName.length; i++) {
        // if (kikakuName[i].checked) {
        if (kikakuName[i].classList.contains('current')) {
          this.reservation.item.name += kikakuName[i].dataset.val
        }
      }

      //重複チェック
      for (let i = 0; i < this.reservation.cart.length; i++) {
        if (
          this.reservation.cart[i].cat === 'ホールケーキ' ||
          this.reservation.cart[i].original === 'カットケーキ用メッセージカード'
        )
          continue

        //重複があった場合、個数等だけ増加させてreturn
        if (this.reservation.cart[i].name === this.reservation.item.name) {
          let number = document.getElementById('number')
          if (
            this.reservation.cart[i].cat === 'ホールケーキ' ||
            this.reservation.cart[i].cat === '季節のイベントケーキ'
          ) {
            let candleBig = document.getElementById('candleBig')
            let candleSmall = document.getElementById('candleSmall')
            //ろうそくの数を追加！
            this.reservation.cart[i].candle.big += parseInt(candleBig.value, 10)
            this.reservation.cart[i].candle.small += parseInt(candleSmall.value, 10)
            //メッセージの取得
            let message = document.getElementById('message')
            this.reservation.cart[i].message = message.value
            if (this.message_2_shown) {
              let message_2 = document.getElementById('message_2')
              if (message_2) this.reservation.cart[i].message_2 = message_2.value
              this.reservation.cart[i].message_2_enabled = true
            }
          }
          //個数を取得
          this.reservation.cart[i].number = parseInt(number.value, 10) + parseInt(this.reservation.cart[i].number)
          const addMessage2Price = this.message_2_shown ? 100 : 0
          this.reservation.sum +=
            parseInt(number.value, 10) * (Number(this.reservation.cart[i].price) + addMessage2Price)

          //終了後モーダルを閉じる！
          let modal = document.getElementById('modal')
          modal.style.display = 'none'
          let modalCart = document.getElementById('modalCart')
          modalCart.style.display = 'block'
          //カート内の総個数
          this.reservation.totalCartItemNumber += parseInt(number.value, 10)
          this.returnAppSum()
          this.initKikakuCurrent()
          this.message_2_shown = false
          return
        }
      }

      //重複がなかった場合（カートの中身を増やす）
      this.reservation.cart[this.reservation.count] = {
        name: '',
        price: '',
        number: '',
        image: {},
        candle: { big: 0, small: 0 },
        cut_cake_message: '',
        message: '',
        message_2_enabled: false,
        message_2: '',
        cat: '',
        id: '',
        original: '',
        reserId: ''
      }
      //名前のセット(規格・サイズと合成)
      this.reservation.cart[this.reservation.count].name = this.reservation.item.name
      this.reservation.cart[this.reservation.count].original = this.reservation.item.original
      //金額のセット
      for (let i = 0; i < kikakuName.length; i++) {
        // if (kikakuName[i].checked) {
        if (kikakuName[i].classList.contains('current')) {
          for (let j = 0; j < this.reservation.item.kikaku.length; j++) {
            if (this.reservation.item.kikaku[j].kikaku_size == kikakuName[i].dataset.val) {
              this.reservation.cart[this.reservation.count].price = this.reservation.item.kikaku[j].kikaku_price
            }
          }
        }
      }
      this.reservation.cart[this.reservation.count].image = this.reservation.item.images.reserMain
      this.reservation.cart[this.reservation.count].cat = this.reservation.item.cat
      this.reservation.cart[this.reservation.count].id = this.reservation.item.id
      this.reservation.cart[this.reservation.count].reserId = this.reservation.item.reserId

      //個数の取得
      let number = document.getElementById('number')
      this.reservation.cart[this.reservation.count].number = number.value
      //カート内の総個数
      this.reservation.totalCartItemNumber += parseInt(this.reservation.cart[this.reservation.count].number, 10)
      //this.reservation.sumの計算
      const addMessage2Price = this.message_2_shown ? 100 : 0
      this.reservation.sum +=
        (Number(this.reservation.cart[this.reservation.count].price) + addMessage2Price) *
        this.reservation.cart[this.reservation.count].number

      if (this.reservation.item.cat === 'ホールケーキ' || this.reservation.item.cat === '季節のイベントケーキ') {
        //ろうそくの数の取得
        let candleBig = document.getElementById('candleBig')
        this.reservation.cart[this.reservation.count].candle.big = parseInt(candleBig.value, 10)
        let candleSmall = document.getElementById('candleSmall')
        this.reservation.cart[this.reservation.count].candle.small = parseInt(candleSmall.value, 10)
        //メッセージの取得
        let message = document.getElementById('message')
        this.reservation.cart[this.reservation.count].message = message.value

        if (this.message_2_shown) {
          let message_2 = document.getElementById('message_2')
          if (message_2) this.reservation.cart[this.reservation.count].message_2 = message_2.value
          this.reservation.cart[this.reservation.count].message_2_enabled = true
        }
        this.$forceUpdate()
      }

      if (this.reservation.item.original == 'カットケーキ用メッセージカード') {
        this.reservation.cart[this.reservation.count].cut_cake_message = this.cut_cake_message
      }

      // inputの状態を初期値に戻す
      this.resetForm()

      //終了後モーダルを閉じる！
      let modal = document.getElementById('modal')
      modal.style.display = 'none'

      //カウントを増やす！
      this.reservation.count++

      //カートのモーダルを表示
      let modalCart = document.getElementById('modalCart')
      modalCart.style.display = 'block'

      //カートのボタンを表示
      let modalCartBtn = document.getElementById('pageHeaderCartBtn')
      modalCartBtn.style.display = 'block'

      //商品リストに枠をつける
      let item_select = document.getElementById(this.reservation.item.id)
      item_select.classList.add('border_blue')

      this.returnAppSum()

      //labelのcurrent表示をもとに戻す
      this.initKikakuCurrent()
    },
    initKikakuCurrent() {
      let kikakuLabel = document.getElementsByClassName('kikakuLabel')
      for (let i = 0; i < kikakuLabel.length; i++) {
        kikakuLabel[i].classList.remove('current')
      }
    },
    //小計の計算
    sum: function() {
      this.reservation.hiddenSum = 0
      this.reservation.tax = 0
      let sum = 0
      let hiddenSum = document.getElementsByClassName('hiddenSum')
      for (let i = 0; i < hiddenSum.length; i++) {
        sum += parseInt(hiddenSum[i].textContent, 10)
        this.reservation.hiddenSum = sum
      }
    },
    //カートのitem削除
    deleCartItem: function(index) {
      //枠の変数
      let originalName = this.reservation.cart[index].original
      let originalId = this.reservation.cart[index].id
      let selectFlag = false
      this.reservation.totalCartItemNumber -= parseInt(this.reservation.cart[index].number, 10)
      this.reservation.cart.splice(index, 1)
      this.reservation.count--
      this.reservation.hiddenSum = 0
      this.reservation.tax = 0
      let sum = 0
      let hiddenSum = document.getElementsByClassName('hiddenSum')
      this.reservation.sum -= parseInt(hiddenSum[index].textContent, 10)
      if (this.reservation.cart.length === 0) {
        this.closePopUpCart()
        let modalCartBtn = document.getElementById('pageHeaderCartBtn')
        modalCartBtn.style.display = 'none'
      }
      this.returnAppSum()
      //商品一覧の枠を消す
      for (let i = 0; i < this.reservation.cart.length; i++) {
        if (this.reservation.cart[i].origin === originalName) {
          selectFlag = true
          //trueの場合は枠線を削除する必要なし
          if (selectFlag) {
            break
          }
        }
      }
      if (!selectFlag) {
        let item_select = $('#originalId')
        item_select.parent('.itemBox').css('border', 'solid 3px transparent')
        item_select.removeClass('border_blue')
      }
    },
    //カートのポップアップの非表示
    closePopUpCart: function() {
      let modalCart = document.getElementById('modalCart')
      modalCart.style.display = 'none'
      this.thumDisplay = true //モーダル画像一枚非表示制御 初期化
    },
    //用意できる商品が存在しない場合
    showNoItemText: function() {
      if (this.reservation.showItemList.length === 0) {
        this.seenNoItemtext = true
      } else {
        this.seenNoItemtext = false
      }
    },
    returnAppSum: function() {
      this.$emit('returnAppSum', this.reservation.totalCartItemNumber)
    },
    //カートモーダルのろうそく等の出し分け
    seenInCartContents: function(itemCart) {
      if (itemCart.cat === 'ホールケーキ' || itemCart.cat === '季節のイベントケーキ') {
        return true
      } else {
        return false
      }
    },
    //商品選択のモーダルーraidioボタン選択時のクラス付与！
    radioAddClass: function(index) {
      let kikakuLabel = document.getElementsByClassName('kikakuLabel')
      for (let i = 0; i < kikakuLabel.length; i++) {
        kikakuLabel[i].classList.remove('current')
      }
      kikakuLabel[index].classList.add('current')
    }
  }
}
</script>

<style scoped lang="scss">
a {
  color: #000;
  &hover {
    opacity: 0.7;
    cursor: pointer;
  }
}
.active {
  background-color: #0d446f !important;
}
.btn {
  text-align: center;
  display: block;
  margin-top: 30px;
  padding: 15px 0;
  background-color: #831f17;
  color: #fff;
  width: 80%;
  position: relative;
  @media (max-width: 767.98px) {
    margin: 30px auto;
    width: 100%;
  }
  i {
    color: #fff;
    text-align: right;
    margin-left: 10px;
  }
  &_blue {
    background-color: #0d446f;
    i {
      margin-left: 0;
      margin-right: 10px;
    }
  }
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
}
.step3 {
  // display: flex;
  padding: 0 15px;
  &--main {
    width: 100%;
    //カテゴリー選択のボタン
    .selectCat {
      display: flex;
      align-content: center;
      margin-bottom: 10px;
      @media (max-width: 767.98px) {
        display: block;
      }
      &__text1 {
        margin-bottom: 0;
        margin-top: 3px;
        margin-right: 15px;
        margin-left: 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.64;
        color: #333333;
        width: 30%;
        @media (max-width: 767.98px) {
          width: 100%;
          text-align: center;
          margin-bottom: 10px;
        }
      }
      &BtnBox {
        display: flex;
        flex-wrap: wrap;
        @media (max-width: 767.98px) {
          margin-left: 8px;
        }
        .category {
          font-size: 14px;
          padding: 3px 10px;
          background-color: #ccc;
          color: #fff;
          border: none;
          border-radius: 50px;
          margin-right: 10px;
          margin-bottom: 4px;
          @media (max-width: 767.98px) {
          }
          &:hover {
            opacity: 0.7;
            cursor: pointer;
          }
        }
      }
    }
    //商品一覧
    .itemList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .itemBox {
        width: 19%;
        padding: 0;
        padding-bottom: 10px;
        border: #d8d8d8 solid 1px;
        margin-bottom: 5px;
        &.none {
          height: 0;
          margin: 0;
          padding: 0;
          border: none;
        }
        @media (max-width: 767.98px) {
          width: 32%;
        }
        &:hover {
          opacity: 0.7;
          cursor: pointer;
        }
        &--imgBlock {
          position: relative;
          margin-bottom: 6px;
          min-height: 100px;
          overflow: hidden;
          &--img {
            max-width: 100%;
          }
          i {
            position: absolute;
            top: 0px;
            right: 0px;
            z-index: 10;
            font-size: 13.5px;
            font-weight: bold;
            line-height: 1.26;
            text-align: center;
            color: #ffffff;
            background-color: #0d446f;
            padding: 5px;
          }
        }
        &--categoryName {
          padding: 2px 7px;
          border-radius: 50px;
          background-color: #0d446f;
          font-size: 9px;
          font-weight: 500;
          line-height: 1.7;
          text-align: center;
          color: #ffffff;
          margin-bottom: 0;
        }
        &--itemName {
          font-size: 12px;
          font-weight: 500;
          line-height: 1.42;
          text-align: center;
          color: #333333;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        &--itemPrice {
          font-size: 14px;
          font-weight: 500;
          line-height: 1.21;
          text-align: center;
          color: #333333;
          margin-bottom: 0;
        }
      }
    }
  }
}

#modal {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  @media (max-width: 767.98px) {
    overflow-y: auto;
  }
  &--whiteBlock {
    position: absolute;
    top: 10vh;
    left: 0;
    right: 0;
    width: 80%;
    margin: auto;
    margin-bottom: 50px;
    background: #fff;
    z-index: 20;
    @media (min-width: 1200px) {
      width: 60%;
    }
    @media (max-width: 767.98px) {
      width: 90%;
      top: 50px;
    }
  }
  &--contents {
    position: relative;
    .stopButton {
      position: absolute;
      top: -20px;
      right: 5px;
      margin-top: 0;
      font-size: 40px;
      @media (max-width: 767.98px) {
        font-size: 30px;
        top: -5px;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .modal--content {
      display: flex;
      @media (max-width: 767.98px) {
        display: block;
      }
      &Img {
        width: 35%;
        @media (max-width: 767.98px) {
          width: 90%;
          margin: auto;
        }
        &--main {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
        &--thum {
          display: flex;
          flex-wrap: wrap;
          max-width: 100%;
          img {
            width: 33%;
            max-height: 100px;
            height: auto;
            object-fit: cover;
            padding: 3px;
            cursor: pointer;
            @media (min-width: 1200px) {
              max-height: 120px;
            }
            @media (max-width: 991.98px) {
              max-height: 70px;
            }
            @media (max-width: 767.98px) {
              max-height: 170px;
            }
            @media (max-width: 575.98px) {
              max-height: 90px;
            }
          }
        }
      }
      &Form {
        width: 65%;
        padding-left: 18px;
        @media (max-width: 767.98px) {
          width: 100%;
          padding-left: 0;
          margin-right: 0;
          margin-top: 30px;
        }
        @media (max-width: 575.98px) {
          margin-top: 15px;
        }
        &__desc {
          font-size: 12px;
        }
        &__number {
          border-bottom: 1px #ccc solid;
          padding-bottom: 8px;
          display: flex;
          align-items: center;
          &--label {
            display: flex;
            margin-right: 10px;
            margin-bottom: 0;
            text-align: left;
            font-size: 14px;
            font-weight: 500;
            line-height: 2.21;
            text-align: left;
            color: #333333;
            @media (max-width: 767.98px) {
            }
          }
          &--input {
            // margin-left: 100px;
            margin-left: 30px;
            margin-right: 15px;
            border-radius: 3px;
            background-color: #ffffff;
            border: solid 1px #cccccc;
            text-align: center;
            max-width: 70px;
            @media (max-width: 767.98px) {
              // margin-left: 100px;
            }
            &.form-control {
              width: auto;
            }
          }
          &_input {
            display: flex;
            width: 15%;
          }
        }
      }
    }
  }
}
.modal {
  overflow-y: scroll;
  &__contents {
    margin: 50px 30px;
    @media (max-width: 767.98px) {
      width: 90%;
      margin: 20px auto;
    }
    &--itemName {
      font-size: 21px;
      font-weight: 500;
      line-height: 1.48;
      text-align: left;
      color: #333333;
      @media (max-width: 767.98px) {
        padding-top: 35px;
      }
      @media (max-width: 575.98px) {
        padding-top: 20px;
      }
    }
  }
  @media (max-width: 575.98px) {
    .btn {
      margin: 10px 0;
    }
  }
  &--content {
    &Form {
      &__candle {
        border-bottom: 1px #ccc solid;
        padding-top: 8px;
        padding-bottom: 8px;
        margin-bottom: 15px;
        display: flex;
        @media (max-width: 767.98px) {
          display: block;
        }
        .div {
          display: flex;
        }
        &--text1 {
          font-size: 14px;
          font-weight: 500;
          line-height: 2.21;
          text-align: left;
          color: #333333;
          margin-right: 30px;
          @media (max-width: 767.98px) {
            margin-right: 15px;
          }
        }
        &--text2 {
          font-size: 14px;
          font-weight: 500;
          line-height: 2.21;
          text-align: left;
          color: #333333;
          margin-right: 5px;
        }
        .inputNumber {
          display: inline-block;
          &.form-control {
            width: auto;
          }
        }
      }
      &__msg {
        border-bottom: 1px #ccc solid;
        padding-bottom: 8px;
        display: flex;
        align-items: center;
        @media (max-width: 767.98px) {
          display: block;
        }
        &--label {
          width: 33%;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.43;
          text-align: left;
          color: #333333;
          margin-bottom: 0;
          @media (max-width: 767.98px) {
            width: 100%;
            border-bottom: 0;
            padding-bottom: 8px;
            margin-bottom: 0;
          }
        }
        &--input {
          width: 67%;
          border-radius: 3px;
          background-color: #ffffff;
          border: solid 1px #cccccc;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.64;
          text-align: left;
          padding: 5px;
          @media (max-width: 767.98px) {
            width: 100%;
            border-bottom: 1px #ccc solid;
            padding-bottom: 8px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
.modal_cart {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  overflow-y: scroll;
  &_white {
    background: #fff;
    position: absolute;
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    width: 80%;
    margin: auto;
    margin-bottom: 80px;
    z-index: 20;
    @media (min-width: 1200px) {
      width: 60%;
    }
    @media (max-width: 767.98px) {
      width: 90%;
      top: 50px;
    }
  }
  .stopButton {
    position: absolute;
    top: 10px;
    right: 15px;
    margin-top: 0;
    font-size: 40px;
    &:hover {
      cursor: pointer;
    }
  }
  .step3--cart {
    a {
      width: 30%;
      text-align: center;
      margin: auto;
      display: block;
    }
    padding: 0 10px;
    margin-top: 30px;
    &__title {
      border-bottom: 1px gray solid;
      padding-bottom: 30px;
      margin-bottom: 0;
    }
    &--list {
      position: relative;
      padding-top: 15px;
      border-bottom: 1px gray solid;
      display: flex;
      @media (max-width: 767.98px) {
        padding-top: 55px;
      }
      .hiddenSum {
        display: none;
      }
      &__img {
        width: 30%;
      }
      &__price {
        width: 70%;
        margin-left: 30px;
        @media (max-width: 575.98px) {
          margin-left: 10px;
        }
        &--number {
          font-size: 14px;
          font-weight: 500;
          line-height: 1.5;
          text-align: left;
          color: #333333;
        }
      }
      &__dele {
        position: absolute;
        top: 50%;
        margin-top: -20px;
        right: 0px;
        border-radius: 50px;
        background-color: #cccccc;
        padding: 10px 25px;
        @media (max-width: 767.98px) {
          font-size: 12px;
          top: 30px;
        }
        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }
      }
    }
    &__sum {
      font-size: 13px;
      font-weight: 500;
      line-height: 2.15;
      text-align: left;
      color: #333333;
      p {
        text-align: right;
        margin-top: 5px;
        margin-bottom: 10px;
      }
      span {
        font-size: 21px;
        font-weight: 500;
        line-height: 1.33;
        text-align: right;
        color: #333333;
      }
    }
  }
  .btnBox {
    display: flex;
    margin: 30px;
    @media (max-width: 767.98px) {
      display: block;
    }
    button {
      margin: 5px;
    }
  }
}
.label_kikaku {
  border-bottom: 1px solid #ccc;
  &__p {
    margin-top: 15px;
    margin-bottom: 15px;
    input,
    label {
      cursor: pointer;
    }
    &.form-control {
      width: auto;
    }
  }
}
//枠線
.border_blue {
  // border: solid 3px #0d446f !important;
  // border: solid 3px #fff !important;
}
.d_none {
  display: none !important;
}
//labelのスタイル
.kikakuLabel {
  display: flex;
  align-items: center;
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
  }

  .select_radio_btn {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    border: 1px solid #7e7e7e;
  }
  &.current {
    .select_radio_btn {
      position: relative;
      border-color: #0075fe;

      &::after {
        content: '';
        border-radius: 50%;
        position: absolute;
        background: #0075fe;
        width: 8px;
        height: 8px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .kikakuLabel__txt {
      background-color: #f5f5f5;
    }
  }
  &__txt {
    padding: 0 10px;
  }
  input {
    margin-right: 10px;
    margin-top: -2px;
    display: block;
  }
}
//サイズの注意書き
.noticeSize {
  font-size: 15px;
  text-align: center;
  border: 1px solid #000;
  padding: 10px 5px;
  margin-bottom: 30px;
  ul {
    margin-top: 15px;
    margin-bottom: 0;
    text-align: left;
    font-size: 13px;
    list-style: none;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 767.98px) {
      margin-top: 10px;
    }
    @media (max-width: 575.98px) {
      padding: 0 5px;
    }
    li {
      width: 50%;
      margin-bottom: 5px;
      @media (max-width: 767.98px) {
        width: 100%;
      }
    }
  }
}
.numberNotice {
  font-size: 12px;
  margin: 5px 0;
}
.catBtn {
  border: 1px #000 solid !important;
  color: #000 !important;
  &.active {
    color: #fff !important;
  }
}

.caution {
  font-size: 77%;
  color: red;
  font-weight: bold;
  margin-bottom: 1rem;
}

// メッセージ2枚目
.message-2-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  .message-2 {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    font-size: 14px;
    line-height: 1.5;
    &__label {
      font-size: 14px;
      text-align: left;
      color: #333333;
      margin-bottom: 0;
      margin-left: 0.5rem;
      &_tax {
        padding-left: 0.5rem;
        font-size: 12px;
      }
    }
    &__input {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      text-align: left;
      padding: 5px;
    }
  }
}

// カート内
.cart-second-message {
  margin-top: 1rem;
  .second-message-icon {
    margin-right: 0.5rem;
  }
}
</style>
